import en from "../localization/en.json";

export enum LanguageEnum {
    English = 'en',
    Italian = 'it',
    Spanish = 'es',
    SpanishArgentina = 'esAr',
    Portuguese = 'pt',
    German = 'de'
};

export const LanguageName: { [key in LanguageEnum]: string} = {
    'en': "English",
    'it': "Italiano",
    'es': "Español",
    'esAr': "EspañolArgentina",
    'pt': "Portuguese",
    'de': "Deutsch"
};

export const languages = Object.values(LanguageEnum).sort();

export type LocalStrings = typeof en;

export const isLanguageValid = (langs: (string|undefined)[] | undefined) => {
    if(langs !== undefined && langs.length > 0) {
        return langs.every((lang) => lang !== undefined && Object.values(LanguageEnum).includes(lang as LanguageEnum));
    }
    else return false
}
